import request from '@/utils/request';

export function builtPut(data) {
    return request({
        url: '/board/mavin/actions/built',
        method: 'post',
        data: data
    });
}

export function getPrecise(idCard, mobile) {
    return request({
        url: `/board/mavin/precise/${idCard}/${mobile}`,
        method: 'get'
    });
}

export function savePrecise(idCard) {
    return request({
        url: `/board/mavin/precise/${idCard}`,
        method: 'post'
    });
}

export function deleteData(mavinEid, mavinType) {
    return request({
        url: `/board/mavin/${mavinEid}/${mavinType}`,
        method: 'delete'
    });
}